export const ALVIE_DATASOURCE_KEY = 'alvie'
export const GA4_DATASOURCE_KEY = 'ga'
